module.exports = __webpack_public_path__ + "static/travel-e9730cb56e7380a5bacbbc4622e54d29.jpg";